import React, { Component } from "react";
import Switch from "react-switch";

export class MemberAddSwitchBtn extends Component {
  constructor(props) {
    super(props);

    const data = this.props.data;
    this.state = {
      isAdmin: data.isAdmin,
      email: data.memberEmail,
    };

    this.changeHandler = this.changeHandler.bind(this);
  }

  changeHandler() {
    const isChecked = this.state.isAdmin;
    this.setState({ isAdmin: !isChecked }, () => {
      const { dataCallBack } = this.props;
      dataCallBack(this.state);
    });
  }

  render() {
    return (
      <Switch onChange={this.changeHandler} checked={this.state.isAdmin} />
    );
  }
}

export default MemberAddSwitchBtn;
